import React, { useEffect } from "react";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";
import { getSiteUrlWithoutProtocol, getSiteEmail } from "../Helpers/SiteConfig";
import usePageMeta from "../Helpers/usePageMeta";

const Privacy = () => {
  usePageMeta({
    title: "Privacy Policy | TZ Creation",
    description: "How TZ Creation collects, uses and protects your information.",
    path: "/privacy-policy",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header />
      <Breadcrumb parentpageName="Home" currentPageName="Privacy Policy" />
      <section className="privacy-section mb-5 section-gap">
        <div className="container py-3 text-dark">
          <div className="row">
            <div className="col-md-12">
              <h1 className="text-uppercase mb-4">Privacy Policy</h1>
              <p>
                We understand that privacy is important for the visitors of
                <a href="/"> www.{getSiteUrlWithoutProtocol()}</a> ("Site"). We make every
                effort to protect the visitors' privacy and of the individuals
                who provide their personal information to the site. We have
                described the efforts below, and by using our site, you agree to
                this Privacy Policy.
              </p>

              <h2 className="mt-5 mb-2">TZ Creation collects the following:</h2>

              <ol>
                <li>
                  Voluntarily send personal information, such as name and
                  surname, addresses, phone numbers, and email addresses. For
                  example, TZ Creation may collect your information from you to
                  respond to a blog by one of our staff or perhaps allow us to
                  respond to a question from you;
                </li>

                <li>
                  We receive and store only particular types of information
                  whenever you contact us. For example, like most sites, we use
                  "cookies."
                </li>

                <li>
                  "Cookies" are bits of information a website transfers to a
                  person's hard drive for recording purposes. TZ Creation uses
                  cookies for various purposes to track your online data while
                  you are on the site. For example, we track who has visited our
                  site. There is always an option to disable cookies in your
                  browser if you wish;
                </li>
                <li>IP addresses;</li>
                <li>The information included on the pages people visit;</li>
                <li>
                  Analytics details such as application types and versions,
                  operating system, screen adjustment, color depth, network
                  location, language, and time spent on the site.
                </li>
              </ol>

              <h2 className="mt-5 mb-2">
                The information we collect is utilized for various purposes:
              </h2>

              <ol>
                <li>Internal review;</li>
                <li>Improve the content of our site;</li>
                <li>
                  Informs users (who provide us with voluntary contact details
                  and agree to be contacted by TZ Creation) of upcoming events,
                  exciting details, and regular TZ Creation updates.
                </li>
              </ol>

              <p className="mt-4">
                TZ Creation currently does not sell or share personal
                information with third parties, nor do we have many partners. We
                will only email you about TZ Creation updates when you request
                or subscribe to one of our services. And - if at any time you do
                not want to receive an email from us, all you need to do is
                inform us at{" "}
                <a href={`mailto:${getSiteEmail()}`}>{getSiteEmail()}</a>.
              </p>

              <p>
                We must retain the right to use or disclose any information as
                required to satisfy any law, regulation, or lawful request, to
                protect the integrity of the site or the policies of the site or
                to prevent unauthorized use of the site, or to co-operate with
                any law enforcement investigation or public safety inquiries. We
                must also reserve the right to share information with the next
                business associated with the merger, sale of products, or other
                company changes in connection with the site.
              </p>

              <p>
                We take every precaution to ensure the security of your personal
                information. Access is limited to those involved in the
                management or execution of a request or investigation. For your
                information, entertainment, and various other reasons, this site
                contains links to other sites. TZ Creation no longer deals with
                the privacy practices or content of those websites. We may wish
                to use customer information to discover new, unexpected items
                not included in our privacy notice from time to time. If our
                information practices change from time to time in the future, we
                will post policy changes on our site to notify you of these
                changes and empower you to opt-out of these new methods. If you
                are concerned about how your information is being used, please
                review our site from time to time.
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Privacy;
